
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Styled from "./LiveStreams.styled";
import { LayoutTemplates, Loader } from "../../../libs";
import { SelectTemplate } from "../select-template";
import { userService } from "../../../services";
import { toast } from "react-toastify";


export const LiveStreams: React.FC = () => {
  const navigate = useNavigate();
  const [templateId, setTemplateId] = useState<LayoutTemplates>(LayoutTemplates.Layout1);
  const [originalTemplateId, setOriginalTemplateId] = useState<LayoutTemplates>(LayoutTemplates.Layout1);
  const [loading, setLoading] = useState<boolean>(true);

  const fetchLiveStreamLayout = React.useCallback(async () => {
    const layoutValue = await userService.getUserKVStoreKey("liveStreamLayout");
    if (layoutValue?.value) {
      setTemplateId(parseInt(layoutValue.value));
      setOriginalTemplateId(parseInt(layoutValue.value));
    } else {
      setTemplateId(LayoutTemplates.Layout1);
    }
    setLoading(false);
  }, [setLoading, setTemplateId]);

  const saveLiveStreamLayout = React.useCallback(async () => {
    setLoading(true);
    try {
      await userService.setUserKVStoreKey("liveStreamLayout", templateId);
      setLoading(false);
      setOriginalTemplateId(templateId);
      toast.success("Live stream layout saved successfully!");
    } catch (error) {
      console.error("Error saving live stream layout:", error);
      toast.error("Failed to save live stream layout.");
      setLoading(false);
    }
  }, [templateId, setLoading]);

  React.useEffect(() => {
    fetchLiveStreamLayout();
  }, [fetchLiveStreamLayout]);

  return (
    <Styled.StyledContainer>
      <Styled.Header>
        <Styled.LeftSection>
          Live Streams
        </Styled.LeftSection>
        <Styled.RightSection>
          <Styled.CustomButton variant="outline-secondary" onClick={() => navigate(-1)}>Go Back</Styled.CustomButton>
          <Styled.SaveButton variant="primary" onClick={saveLiveStreamLayout}>Save</Styled.SaveButton>
        </Styled.RightSection>
      </Styled.Header>
      <Styled.Description>
        Here you can organize all the live streams to see how they will appear on your page.
      </Styled.Description>
      <Styled.SelectTemplateWrapper>
        {
          loading && (
            <Styled.LoadingOverlay>
              <Loader />
            </Styled.LoadingOverlay>
          )
        }
        <SelectTemplate
          onBack={() => navigate(-1)}
          selectedTemplate={templateId}
          onTemplateSelect={setTemplateId}
          excludeTemplates={[LayoutTemplates.Layout6]}
          changed={originalTemplateId !== templateId} />
      </Styled.SelectTemplateWrapper>
    </Styled.StyledContainer>
  )
};
